// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__deT66","blocks":"Footer_blocks__0M3Dj","head1":"Footer_head1__nKBEr","head2":"Footer_head2__YmRKj","block":"Footer_block__kznbb"};